import React from "react";
import {
  Card,
  Flex,
  Heading,
  Divider,
  TextField,
  Button,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Text,
} from "@aws-amplify/ui-react";
import { Icon } from "@aws-amplify/ui-react";
import { FiTrash, FiEdit, FiPlusSquare } from "react-icons/fi";

import { useForm, Controller } from "react-hook-form";
import { useUserQuery } from "../../common/useUserQuery";
import { useNavigate } from "react-router-dom";
import { useAppointmentsQuery } from "../api/appointments/useAppointmentsQuery";
import { useAppointmentDeleteMutation } from "../api/appointments/useAppointmentsMutation";

export default function AppointmentContainer() {
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm();
  const { data: userQuery } = useUserQuery();
  const { data: appointmentsQuery, isFetching } = useAppointmentsQuery(
    userQuery?.patientUserId
  );
  const { mutate: appointmentDeleteMutate } = useAppointmentDeleteMutation();

  const handleOnDeleteClick = (appointmentId) => {
    appointmentDeleteMutate(appointmentId);
  };

  const handleOnEditClick = (appointmentId) => {
    navigate(`/user/quick-actions/appointment-reminder/${appointmentId}/edit`);
  };

  const convertToStandardTime = (militaryTime) => {
    const [hour, minute] = militaryTime.split(":");
    const hourInt = parseInt(hour, 10);
    const period = hourInt >= 12 ? "PM" : "AM";
    const standardHour = hourInt % 12 || 12; // Convert 0 to 12 for midnight
    return `${standardHour}:${minute} ${period}`;
  };

  return (
    <Card variation="elevated" flex={1}>
      <Flex direction={"row"} gap={12}>
        <Heading level={5} children={`Appointment Reminders`} />
        <Button
          variation="primary"
          size="small"
          onClick={() =>
            navigate("/user/quick-actions/appointment-reminder/add")
          }
        >
          Add
        </Button>
      </Flex>

      <Flex direction={"column"} gap={12} marginTop={12}>
        <Divider size="small" />

        {isFetching ? (
          <span>Loading...</span>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell as="th">Actions</TableCell>
                <TableCell as="th">Provider</TableCell>
                <TableCell as="th">Location</TableCell>
                <TableCell as="th">Date</TableCell>
                <TableCell as="th">Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {appointmentsQuery?.map((ap) => (
                <TableRow key={`ac_ap_${ap?.id}`}>
                  <TableCell>
                    <Flex
                      gap={6}
                      direction={{ base:"column", medium: "row" }}
                    >
                      <Button
                        variation="link"
                        size="small"
                        colorTheme="error"
                        onClick={handleOnDeleteClick.bind(this, ap?.id)}
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variation="link"
                        size="small"
                        onClick={handleOnEditClick.bind(this, ap?.id)}
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variation="link"
                        size="small"
                        onClick={() =>
                          navigate(
                            `/user/hr/encounter/${ap?.providerUserId}/add`
                          )
                        }
                      >
                        <FiPlusSquare />
                      </Button>
                    </Flex>
                  </TableCell>
                  <TableCell>{ap?.providerName}</TableCell>
                  <TableCell>{`${ap?.appointmentAddress1} ${ap?.appointmentAddress2} ${ap?.appointmentCity} ${ap?.appointmentState}`}</TableCell>
                  <TableCell>{ap?.appointmentDate}</TableCell>
                  <TableCell>
                    {convertToStandardTime(ap?.appointmentTime)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Flex>
    </Card>
  );
}
